var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "validation", attrs: { tag: "form" } },
    [
      _c(
        "div",
        [
          _c(
            "el-card",
            { staticClass: "card-container", attrs: { shadow: "hover" } },
            [
              _c("h3", [_vm._v("Dados da Ordem de Serviço")]),
              _c(
                "el-row",
                { attrs: { gutter: 30 } },
                [
                  _c(
                    "el-col",
                    { staticClass: "container-input", attrs: { span: 18 } },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("app-label", {
                                  attrs: {
                                    label: "Nº da Ordem de Serviço:",
                                    required: true
                                  }
                                }),
                                _c("el-input", {
                                  staticClass: "input",
                                  class: {
                                    erro: errors.length || _vm.numeroExistente
                                  },
                                  attrs: {
                                    name: "Numero",
                                    maxlength: 50,
                                    required: true
                                  },
                                  on: { blur: _vm.checaNumeroOs },
                                  model: {
                                    value: _vm.ordemServico.numero,
                                    callback: function($$v) {
                                      _vm.$set(_vm.ordemServico, "numero", $$v)
                                    },
                                    expression: "ordemServico.numero"
                                  }
                                }),
                                _c("span", { staticClass: "help erro" }, [
                                  _vm._v(_vm._s(errors[0]))
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "container-input", attrs: { span: 6 } },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("app-label", {
                                  attrs: { label: "Municipio:", required: true }
                                }),
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "input",
                                    class: { erro: errors.length },
                                    attrs: {
                                      clearable: "clearable",
                                      filterable: "filterable",
                                      name: "municipio"
                                    },
                                    nativeOn: {
                                      keyup: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.consultar($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.ordemServico.municipio.id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.ordemServico.municipio,
                                          "id",
                                          $$v
                                        )
                                      },
                                      expression: "ordemServico.municipio.id"
                                    }
                                  },
                                  _vm._l(_vm.municipios, function(item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.nome,
                                        value: item.id
                                      }
                                    })
                                  }),
                                  1
                                ),
                                _c("span", { staticClass: "help erro" }, [
                                  _vm._v(_vm._s(errors[0]))
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "container-input" },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          return [
                            _c("app-label", {
                              attrs: {
                                label: "Upload da Ordem de Serviço",
                                required: true
                              }
                            }),
                            _c("app-anexo", {
                              attrs: {
                                id: "upload-ordem-servico",
                                files: _vm.documentos,
                                showAnexar: _vm.documentos.length === 0,
                                errors: errors,
                                scope: "documentos"
                              },
                              on: {
                                removeFile: _vm.removeFile,
                                uploadFile: _vm.uploadFile,
                                downloadDocumentoCadastro: _vm.download
                              },
                              model: {
                                value: _vm.documentos,
                                callback: function($$v) {
                                  _vm.documentos = $$v
                                },
                                expression: "documentos"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("app-listagem", {
            attrs: {
              showButton: false,
              "json-headers": _vm.headers,
              "json-data": _vm.analistas,
              totalElements: _vm.totalElements,
              pagina: _vm.pagina,
              headerLabel: "Vincular Equipe",
              hasRefreshButton: true,
              busca: true,
              paginate: true,
              expandir: false
            },
            on: {
              selectItem: _vm.selecionaItem,
              updateListagem: _vm.buscar,
              changePage: _vm.changePage,
              changeTotal: _vm.changeTotal
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-133952d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133952d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/ordemServico/DadosOrdemServico.vue
// module id = null
// module chunks = 